import { css, cx } from "@emotion/css";
import { borderRadius, borderWidth, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
export interface CounterBadgeProps {
    /** The visual style of the badge */
    type: "solid" | "outlined";
    /** The text content to display in the badge */
    label: string;
}
export function CounterBadge({ type, label }: CounterBadgeProps) {
    return <div className={cx(styles.root, type === "solid" ? styles.solid : styles.outlined)}>{label}</div>;
}
const styles = {
    root: css({
        display: "inline-block",
        borderRadius: borderRadius.circle,
        alignContent: "center",
        font: text.body.bold.small,
        padding: `0 ${space[6]}`,
    }),
    solid: css({
        color: themeTokens.color.text.primary,
        backgroundColor: themeTokens.color.background.tertiary,
    }),
    outlined: css({
        color: themeTokens.color.text.secondary,
        boxShadow: `inset 0 0 0 ${borderWidth[1]} ${themeTokens.color.border.primary}`,
    }),
};
